import React, { useContext } from "react"
import { graphql, useStaticQuery } from "gatsby"

import Grid from "../shared/grid"
import IconContent from "./icon-content"
import { UIContext } from "../shared/layout"
import Slider from "react-slick"
import {
  ContentWrapper,
  Title,
  PerksWrapper,
  PerksCardSliderWrapper,
} from "./perks-benefits.style"

const PerksBenefits = () => {
  const {
    teamEventIcon,
    townhallIcon,
    learningIcon,
    vacationIcon,
    remoteIcon,
    hackedinIcon,
  } = useStaticQuery(graphql`
    query {
      teamEventIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Perks Icons/team_events.svg"
        }
      ) {
        publicURL
      }
      townhallIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Perks Icons/townhalls.svg"
        }
      ) {
        publicURL
      }
      learningIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Perks Icons/learning_development.svg"
        }
      ) {
        publicURL
      }
      vacationIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Perks Icons/vacation.svg"
        }
      ) {
        publicURL
      }
      remoteIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Perks Icons/remote_work.svg"
        }
      ) {
        publicURL
      }
      hackedinIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Perks Icons/hackedin.svg"
        }
      ) {
        publicURL
      }
    }
  `)
  return (
    <ContentWrapper>
      <Grid>
        <Title>Perks and benefits</Title>
        <PerksCardContainer>
          <IconContent
            icon={teamEventIcon.publicURL}
            title="Team Events"
            description="Getting together as a team to unwind and do something fun allows us to grow the team dynamic and build stronger relationships."
          />
          <IconContent
            icon={townhallIcon.publicURL}
            title="Company Town halls"
            description="Taking a full morning to share wins and learnings from the previous quarter along with games and guest speakers allows us to reset for the upcoming quarter."
          />
          <IconContent
            icon={learningIcon.publicURL}
            title="Learning & Development"
            description="Alignment and ownership are key to success at Mappedin. We do this by setting goals and re-visiting them as business needs shift."
          />
          <IconContent
            icon={vacationIcon.publicURL}
            title="Flexible Vacation"
            description="Mappedin’s fast-paced environment requires time to reflect, reset, and remotivate. We encourage our team to take vacation as needed."
          />
          <IconContent
            icon={remoteIcon.publicURL}
            title="Remote Working"
            description="We encourage employees to find what works best for them and their team. Regardless of your location, we have best practices to keep collaboration high."
          />
          <IconContent
            icon={hackedinIcon.publicURL}
            title="Quarterly Three Day Hackedin"
            description="Every quarter, our developers participate in a three-day hackathon where they are encouraged to expand their skillset and work on unique solutions for a specified theme."
          />
        </PerksCardContainer>
      </Grid>
    </ContentWrapper>
  )
}

export default PerksBenefits

const PerksCardContainer = ({ children }) => {
  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)
  return breakpoint === "sm" && clientLoaded ? (
    <PerksCardSliderWrapper>
      <Slider dots>{children}</Slider>
    </PerksCardSliderWrapper>
  ) : (
    <PerksWrapper>{children}</PerksWrapper>
  )
}
